// extracted by mini-css-extract-plugin
module.exports = {"videoBackground":"VideoBackground_videoBackground__84R_p","mobile":"VideoBackground_mobile__Df4I5","withoutMobile":"VideoBackground_withoutMobile__uLt9_"};